import Period from "./Period";
class SwapBenchmark {
    currency;
    dayCountFraction;
    frequency;
    reference;
    side;
    tenor;
    constructor(response) {
        this.currency = response.currency;
        this.dayCountFraction = response.dayCountFraction;
        this.frequency = response.frequency;
        this.reference = response.reference;
        this.side = response.side;
        this.tenor = response.tenor !== undefined ? new Period(response.tenor) : undefined;
    }
    printShort() {
        return this.side === 'ASW' ? 'ASW' : 'MS';
    }
}
export default SwapBenchmark;
